import angular from 'angular';
import {
  loaderService,
  reportsDataService,
  ssDialogService
} from 'app/services';
import {
  alerts,
  confirmDialog,
  actionIcon
} from 'app/components/global';
import directive from './report-package-config-report-param.directive';
import controller from './report-package-config-report-param.controller';


export default angular.module('app.components.reports.packageReports.reportPackageConfigReportParam', [
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  loaderService,
  actionIcon,
])
  .directive('prReportPackageConfigReportParam', directive)
  .controller('PRReportPackageConfigReportParamController', controller)
  .name;

console.log('app.components.reports.packageReports.reportPackageConfigReportParam created');
